import { render, staticRenderFns } from "./RequestsTableRedesigned.vue?vue&type=template&id=047d6e17&scoped=true"
import script from "./RequestsTableRedesigned.vue?vue&type=script&lang=js"
export * from "./RequestsTableRedesigned.vue?vue&type=script&lang=js"
import style0 from "./RequestsTableRedesigned.scss?vue&type=style&index=0&id=047d6e17&prod&scoped=true&lang=scss&external"
import style1 from "./RequestsTableRedesigned-popover.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d6e17",
  null
  
)

export default component.exports